<template>
  <p class="chat-user-message text-truncate mb-0">
    <i
      v-if="isOutgoing"
      class="ri-reply-fill mr-1"
    />
    <template v-if="hasAttachment">
      <i
        class="align-middle me-1 ms-0"
        :class="[AttachmentTypeIcon[messageLast.attachment.type]]"
      />
      {{ $t(`rooms.type.${messageLast.attachment.type}`) }}
    </template>
    <span
      v-else
      v-html="payload"
    />
  </p>
</template>

<script>
import {mapGetters} from "vuex";

export const AttachmentTypeIcon = {
  image: 'ri-image-fill',
  document: 'ri-file-text-fill',
  video: 'ri-video-fill',
};

export default {
  name: 'ContentRoomsComponents',
  props: {
    isOutgoing: {type: Boolean, default: false},
    messageLast: {type: Object, default: () => ({})},
  },
  data() {
    return {
      AttachmentTypeIcon,
    }
  },
  computed: {
    ...mapGetters('rooms', [
      'searchMod',
    ]),
    hasAttachment() {
      return Boolean(this.messageLast.attachment)
    },
    payload() {
      const tmp = document.createElement("DIV");
      tmp.innerHTML = this.messageLast.payload;

      let payload = tmp.textContent || tmp.innerText;

      if (this.searchMod) {
        const {query: q} = this.$store.state.rooms.fetchFilter

        const indexPre = 10
        let findIndex = payload.indexOf(q) - indexPre
        if (findIndex < 0) {
          findIndex = 0
        }

        return (
          (findIndex > 0 ? '...' : '') +
          payload.substr(findIndex).replaceAll(new RegExp(q, "ig"), '<strong>$&</strong>')
        )
      }

      return payload
    },
  },
}
</script>
